export const students = [
    {
        sr: 1,
        name: "Warren Findlay",
        phone: "+17065101550",
        email: "Warren_Findlay@gmail.com",
        status: "Not Attending",
        labelStatus: "label-info"
    },
    {
        sr: 2,
        name: "Melissa Newman",
        phone: "+17067514745",
        email: "Melissa_Newman@gmail.com",
        status: "Attending",
        labelStatus: "label-success"
    },
    {
        sr: 3,
        name: "Carlos Infante",
        phone: "+17065101550",
        email: "Carlos_Infante@gmail.com",
        status: "Not Responded",
        labelStatus: "label-danger"
    },
    {
        sr: 4,
        name: "Joel Kerr",
        phone: "+17065101576",
        email: "Joel_Kerr@gmail.com",
        status: "Attending",
        labelStatus: "label-success"
    },
    {
        sr: 5,
        name: "Benjamin Ailleboust",
        phone: "+17065101856",
        email: "Benjamin_Ailleboust@gmail.com",
        status: "Not Attending",
        labelStatus: "label-info"
    }
];


// WEBPACK FOOTER //
// ./src/data/students.js